import { render } from "./Leisure.vue?vue&type=template&id=2dd32252"
import script from "./Leisure.vue?vue&type=script&lang=js"
export * from "./Leisure.vue?vue&type=script&lang=js"

import exportComponent from "/home/psinclair/git/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__